enum BookType {
  Tax = 'Tax',
  Accounting = 'Accounting',
}

export default BookType
